import React from 'react'

const SmallIcon = props => {
  return (
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 511.999 511.999" {...props}>
    <g>
    	<g>
    		<path d="M180.722,331.698c-0.198-2.614-1.419-5.144-3.594-6.946c-1.67-1.383-3.656-2.132-5.669-2.273
    			c-3.63-0.314-26.768-1.695-41.349,12.609c-1.127,1.106-2.15,2.27-3.094,3.472c-0.944-1.202-1.968-2.367-3.095-3.473
    			c-14.569-14.292-37.682-12.924-41.317-12.61c-2.022,0.136-4.021,0.887-5.699,2.277c-2.144,1.775-3.358,4.259-3.583,6.832
    			c-0.532,5.034-2.067,28.152,12.355,42.307h-0.001c9.326,9.153,22.188,11.719,31.34,12.267v18.888c0,5.521,4.477,9.998,9.999,9.998
    			c5.521,0,9.999-4.476,9.999-9.999v-18.888c9.152-0.549,22.014-3.115,31.339-12.266
    			C182.668,359.846,181.265,336.972,180.722,331.698z M99.687,359.62c-4.411-4.329-5.97-11.321-6.456-16.97
    			c5.695,0.689,12.403,2.509,16.687,6.711c4.273,4.194,6.094,10.955,6.764,16.695C110.852,365.506,103.969,363.823,99.687,359.62z
    			 M154.348,359.62c-4.281,4.202-11.166,5.886-16.995,6.436c0.67-5.74,2.491-12.499,6.763-16.694
    			c4.282-4.201,10.988-6.022,16.688-6.711C160.317,348.3,158.759,355.291,154.348,359.62z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M107.727,255.346c-0.185-2.434-1.255-4.803-3.18-6.585c-1.695-1.57-3.794-2.442-5.937-2.625
    			c-3.096-0.286-26.701-1.918-41.499,12.596c-1.126,1.105-2.149,2.269-3.092,3.47c-0.944-1.202-1.967-2.366-3.094-3.472
    			c-14.551-14.273-37.603-12.931-41.323-12.61c-2.44,0.167-4.821,1.225-6.618,3.146c-1.597,1.707-2.481,3.828-2.662,5.995
    			c-0.542,5.129-2.046,28.138,12.359,42.275c9.326,9.153,22.188,11.719,31.34,12.267v19.124c0,5.522,4.477,9.999,9.999,9.999
    			s9.999-4.476,9.999-9.999v-19.124c9.152-0.549,22.014-3.115,31.338-12.266C109.682,283.479,108.277,260.651,107.727,255.346z
    			 M26.69,283.263c-4.224-4.145-5.906-11.073-6.45-16.969c5.694,0.689,12.398,2.51,16.682,6.71
    			c4.273,4.194,6.094,10.955,6.764,16.696C37.856,289.149,30.971,287.467,26.69,283.263z M81.35,283.263
    			c-4.281,4.203-11.166,5.886-16.995,6.437c0.67-5.741,2.49-12.5,6.763-16.694c4.281-4.201,10.983-6.021,16.683-6.71
    			C87.255,272.192,85.573,279.119,81.35,283.263z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<polygon points="12.683,297.535 12.682,297.535 12.682,297.535 		"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M107.732,428.613c-0.183-2.4-1.228-4.739-3.112-6.516c-1.733-1.635-3.901-2.531-6.111-2.696
    			c-3.444-0.301-26.762-1.744-41.389,12.606c-1.127,1.106-2.15,2.27-3.094,3.472c-0.944-1.202-1.968-2.367-3.095-3.473
    			c-14.642-14.363-37.997-12.899-41.344-12.608c-2.225,0.156-4.41,1.055-6.155,2.701c-1.858,1.752-2.899,4.051-3.102,6.417
    			c-0.533,5.057-2.058,28.15,12.355,42.297c9.326,9.153,22.188,11.719,31.34,12.267v18.887c0,5.522,4.477,9.999,9.999,9.999
    			c5.521,0,9.999-4.476,9.999-9.999v-18.888c9.152-0.549,22.014-3.115,31.34-12.266
    			C109.682,456.761,108.274,433.882,107.732,428.613z M26.696,456.54c-4.412-4.33-5.97-11.323-6.456-16.972
    			c5.694,0.688,12.4,2.509,16.687,6.713c4.273,4.194,6.094,10.955,6.764,16.695C37.863,462.425,30.978,460.742,26.696,456.54z
    			 M81.357,456.54c-4.281,4.202-11.166,5.886-16.995,6.437c0.67-5.74,2.49-12.5,6.763-16.694c4.282-4.201,10.981-6.022,16.688-6.711
    			C87.327,445.219,85.768,452.21,81.357,456.54z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M447.937,428.614c-0.181-2.401-1.226-4.74-3.111-6.517c-1.733-1.635-3.901-2.531-6.111-2.696
    			c-3.444-0.301-26.762-1.744-41.389,12.606c-1.127,1.106-2.15,2.27-3.094,3.472c-0.944-1.202-1.968-2.367-3.095-3.473
    			c-14.642-14.363-37.998-12.899-41.344-12.608c-2.225,0.156-4.41,1.055-6.155,2.701c-1.858,1.752-2.899,4.051-3.102,6.417
    			c-0.533,5.057-2.058,28.15,12.355,42.297c9.326,9.153,22.188,11.719,31.34,12.267v18.887c0,5.522,4.477,9.999,9.999,9.999
    			s9.999-4.476,9.999-9.999v-18.888c9.152-0.549,22.014-3.115,31.34-12.266C449.887,456.762,448.479,433.883,447.937,428.614z
    			 M366.902,456.54c-4.412-4.33-5.97-11.323-6.456-16.972c5.694,0.688,12.4,2.509,16.687,6.713
    			c4.273,4.194,6.094,10.955,6.764,16.695C378.069,462.425,371.185,460.742,366.902,456.54z M421.563,456.54
    			c-4.281,4.202-11.166,5.886-16.995,6.437c0.67-5.74,2.49-12.5,6.763-16.694c4.282-4.201,10.981-6.022,16.688-6.711
    			C427.533,445.219,425.975,452.21,421.563,456.54z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M511.687,301.712c-0.162-2.2-1.051-4.359-2.671-6.091c-1.774-1.896-4.118-2.951-6.526-3.137
    			c-3.407-0.304-26.737-1.797-41.417,12.603c-1.126,1.105-2.149,2.27-3.093,3.471c-0.944-1.202-1.967-2.367-3.094-3.473
    			c-14.559-14.281-37.651-12.929-41.308-12.611c-2.209,0.147-4.381,1.025-6.126,2.642c-1.914,1.772-2.981,4.125-3.174,6.544
    			c-0.545,5.215-2,28.135,12.363,42.231c9.326,9.153,22.187,11.719,31.339,12.267v18.887c0,5.522,4.477,9.999,9.999,9.999
    			s9.999-4.476,9.999-9.999v-18.887c9.152-0.549,22.015-3.115,31.339-12.266C513.629,329.845,512.236,307.037,511.687,301.712z
    			 M430.65,329.618c-4.224-4.145-5.905-11.073-6.45-16.969c5.694,0.689,12.398,2.51,16.681,6.709
    			c4.273,4.194,6.094,10.956,6.765,16.696C441.816,335.504,434.931,333.822,430.65,329.618z M485.31,329.618
    			c-4.282,4.203-11.166,5.886-16.995,6.437c0.67-5.74,2.489-12.5,6.763-16.694c4.281-4.2,10.985-6.021,16.683-6.71
    			C491.216,318.547,489.534,325.474,485.31,329.618z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M219.974,418.973c-18.746,0-33.996,15.25-33.996,33.996c0,15.267,10.116,28.213,23.997,32.493v16.504
    			c0,5.522,4.477,9.999,9.999,9.999s9.999-4.476,9.999-9.999v-16.504c13.881-4.28,23.997-17.227,23.997-32.493
    			C253.97,434.224,238.72,418.973,219.974,418.973z M220.611,466.934c-0.212-0.013-0.422-0.032-0.637-0.032
    			s-0.426,0.019-0.637,0.032c-7.422-0.337-13.361-6.462-13.361-13.966c0-7.719,6.279-13.998,13.998-13.998
    			s13.998,6.279,13.998,13.998C233.972,460.472,228.033,466.598,220.611,466.934z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M267.937,330.462c-18.746,0-33.996,15.25-33.996,33.996c0,15.267,10.116,28.213,23.997,32.493v16.504
    			c0,5.522,4.476,9.999,9.999,9.999c5.521,0,9.999-4.476,9.999-9.999V396.95c13.881-4.28,23.997-17.227,23.997-32.493
    			C301.933,345.712,286.683,330.462,267.937,330.462z M268.574,378.424c-0.212-0.013-0.422-0.032-0.637-0.032
    			s-0.426,0.019-0.637,0.032c-7.422-0.337-13.361-6.462-13.361-13.966c0-7.719,6.279-13.998,13.998-13.998
    			c7.719,0,13.998,6.279,13.998,13.998C281.935,371.962,275.996,378.087,268.574,378.424z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M315.993,241.699c-18.746,0-33.996,15.25-33.996,33.996c0,15.267,10.116,28.213,23.997,32.493v16.504
    			c0,5.522,4.477,9.999,9.999,9.999s9.999-4.476,9.999-9.999v-16.504c13.881-4.28,23.997-17.227,23.997-32.493
    			C349.988,256.949,334.738,241.699,315.993,241.699z M316.625,289.66c-0.21-0.013-0.419-0.032-0.632-0.032
    			s-0.422,0.019-0.632,0.032c-7.424-0.334-13.366-6.461-13.366-13.966c0-7.719,6.279-13.998,13.998-13.998
    			s13.998,6.279,13.998,13.998C329.991,283.199,324.05,289.326,316.625,289.66z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M318.386,192.357h-52.387v-28.809c14.01-0.091,38.408-2.812,54.748-18.851c22.24-21.826,19.398-59.477,18.785-65.485
    			c-0.148-2.267-1.065-4.492-2.757-6.258c-1.776-1.855-4.099-2.879-6.478-3.055c-3.245-0.295-19.452-1.399-36.627,3.674
    			c0.83-3.697,1.326-7.528,1.363-11.474c0.293-31.163-28.31-55.751-33.019-59.584c-1.761-1.545-4.067-2.482-6.595-2.482
    			c-2.5,0-4.785,0.918-6.538,2.436c-3.917,3.273-31.537,27.474-31.843,59.094c-0.039,4.13,0.416,8.133,1.222,11.987
    			c-17.027-5.011-33.081-3.961-36.46-3.661c-2.411,0.158-4.771,1.185-6.571,3.065c-1.656,1.73-2.569,3.904-2.744,6.123
    			c-0.577,5.493-3.661,43.605,18.771,65.619h-0.001c16.342,16.04,40.74,18.76,54.749,18.852v28.809H94.015v-28.809
    			c14.01-0.091,38.408-2.812,54.75-18.851c22.258-21.845,19.393-59.544,18.782-65.501c-0.163-2.41-1.195-4.767-3.079-6.562
    			c-1.703-1.625-3.833-2.53-6.013-2.722c-2.875-0.269-19.324-1.488-36.77,3.664c0.83-3.698,1.326-7.53,1.363-11.476
    			c0.293-31.146-28.31-55.749-33.016-59.583c-1.761-1.547-4.07-2.485-6.598-2.485c-2.496,0-4.777,0.916-6.529,2.428
    			C72.977,5.735,45.358,29.89,45.053,61.563c-0.039,4.125,0.428,8.131,1.252,11.996c-17.038-5.021-33.109-3.97-36.49-3.669
    			c-2.411,0.158-4.771,1.185-6.571,3.065c-1.664,1.738-2.578,3.924-2.747,6.153c-0.591,5.639-3.626,43.606,18.774,65.589h-0.001
    			c16.342,16.04,40.74,18.76,54.749,18.852v28.809H10.032c-5.521,0-9.999,4.476-9.999,9.999c0,5.522,4.477,9.999,9.999,9.999
    			h260.485L106.184,496.966c-2.762,4.782-1.123,10.898,3.66,13.659c1.574,0.909,3.294,1.341,4.989,1.341
    			c3.456,0,6.816-1.793,8.669-5l170.107-294.611h24.778c5.521,0,9.999-4.476,9.999-9.999
    			C328.385,196.833,323.908,192.357,318.386,192.357z M148.008,89.674c-0.045,10.948-1.944,29.653-13.251,40.751
    			c-11.339,11.129-29.893,13.044-40.705,13.119c0.361-11.732,3.258-29.613,13.946-40.103
    			C119.316,92.339,137.365,90.007,148.008,89.674z M33.276,130.425c-10.393-10.199-13.202-28.072-13.282-40.754
    			c10.623,0.328,28.702,2.649,40.039,13.769c10.686,10.488,13.583,28.369,13.946,40.105
    			C63.168,143.469,44.613,141.552,33.276,130.425z M65.049,61.754c0.153-15.867,11.268-30.275,18.555-38.028
    			c7.709,7.77,19.595,22.341,19.445,38.187c-0.147,15.886-11.912,30.361-19.505,38.058C75.504,91.418,64.908,76.727,65.049,61.754z
    			 M319.992,89.673c-0.045,10.948-1.943,29.654-13.252,40.752c-11.338,11.129-29.892,13.044-40.704,13.119
    			c0.361-11.732,3.258-29.613,13.945-40.102C291.305,92.335,309.353,90.005,319.992,89.673z M205.261,130.425
    			c-11.311-11.1-13.208-29.807-13.252-40.753c10.628,0.332,28.683,2.659,40.009,13.768c0.667,0.654,1.302,1.337,1.91,2.045
    			c0.314,0.403,0.626,0.799,0.939,1.189c8.353,10.654,10.773,26.265,11.099,36.87C235.154,143.469,216.598,141.552,205.261,130.425z
    			 M237.034,61.755c0.153-15.834,11.266-30.252,18.563-38.025c7.709,7.769,19.587,22.33,19.438,38.183
    			c-0.147,15.885-11.912,30.359-19.504,38.058C247.489,91.416,236.893,76.725,237.034,61.755z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M353.041,192.357h-0.131c-5.521,0-9.999,4.476-9.999,9.999c0,5.522,4.477,9.999,9.999,9.999h0.131
    			c5.521,0,9.999-4.476,9.999-9.999C363.04,196.833,358.562,192.357,353.041,192.357z"/>
    	</g>
    </g>
    <g>
    	<g>
    		<path d="M501.969,192.356h-63.985v-28.808c14.01-0.091,38.408-2.812,54.748-18.851c22.228-21.813,19.41-59.368,18.787-65.465
    			c-0.145-2.273-1.063-4.507-2.759-6.278c-1.776-1.855-4.099-2.879-6.478-3.055c-3.244-0.295-19.451-1.399-36.627,3.674
    			c0.83-3.698,1.326-7.528,1.363-11.475C467.309,30.938,438.709,6.351,434,2.515c-1.761-1.545-4.068-2.482-6.596-2.482
    			c-2.5,0-4.785,0.918-6.538,2.436c-3.917,3.273-31.537,27.474-31.843,59.094c-0.039,4.125,0.428,8.133,1.253,11.999
    			c-17-5.01-33.04-3.977-36.464-3.675c-2.271,0.142-4.505,1.055-6.277,2.745c-1.869,1.782-2.898,4.118-3.071,6.511
    			c-0.594,5.725-3.566,43.625,18.776,65.554c16.343,16.04,40.741,18.76,54.75,18.852v28.808h-31.003
    			c-5.521,0-9.999,4.476-9.999,9.999s4.477,9.999,9.999,9.999h34.74l-164.335,284.61c-2.762,4.782-1.123,10.898,3.66,13.659
    			c1.574,0.909,3.294,1.341,4.989,1.341c3.456,0,6.816-1.793,8.669-5l170.107-294.612h57.153c5.521,0,9.999-4.476,9.999-9.999
    			S507.49,192.356,501.969,192.356z M492.007,89.673c-0.081,12.68-2.891,30.554-13.282,40.752
    			c-11.338,11.129-29.892,13.044-40.703,13.119c0.363-11.735,3.261-29.617,13.944-40.102
    			C463.3,92.325,481.372,90.001,492.007,89.673z M377.245,130.425c-11.309-11.098-13.206-29.805-13.251-40.752
    			c10.63,0.333,28.687,2.663,40.009,13.767c10.683,10.484,13.581,28.344,13.946,40.078
    			C407.117,143.414,388.5,141.472,377.245,130.425z M409.019,61.754c0.153-15.833,11.266-30.251,18.563-38.024
    			c7.709,7.769,19.587,22.33,19.438,38.183c-0.147,15.886-11.914,30.361-19.505,38.058
    			C419.473,91.418,408.878,76.727,409.019,61.754z"/>
    	</g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    </svg>

  )
}

export default SmallIcon
